export const pathBeginsWithRoute = (path: string, route: string) => {
    if (!path || !route) return false;
    return (
        path.toLowerCase().substring(0, route.length) === route.toLowerCase()
    );
};
